<div class="contact-management-widget">
  <div class="contact-management-widget-content">
    <h5>{{ 'contact.management.widget.title' | translate }}</h5>
    <p
      class="contact-management-widget-instruction"
      [innerHtml]="'contact.management.widget.instruction' | translate | markdownTranslate"
    ></p>
  </div>
  <div class="action-wrapper">
    <a class="btn btn-white btn-manage-contacts" [routerLink]="['/contacts']">
      <i class="material-icons">contacts</i>
      <span> {{ 'contact.management.widget.manage.button' | translate }}</span>
    </a>
  </div>
</div>
